"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColumnedDropdownItem = void 0;
// packages
const react_1 = __importStar(require("react"));
const match_1 = __importDefault(require("autosuggest-highlight/match"));
const parse_1 = __importDefault(require("autosuggest-highlight/parse"));
// styles
const DropdownItem_styles_1 = require("./DropdownItem.styles");
const Dropdown_styles_1 = require("./Dropdown.styles");
// components
const Tooltip_1 = require("../Tooltip/Tooltip");
const StyledColumnedDropdownItem = (props) => {
    const { columns, suggestion, query, disabled = false } = props;
    const requiredRefs = (0, react_1.useRef)([]);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        requiredRefs.current = requiredRefs.current.slice(0, columns.length);
    }, [columns]);
    (0, react_1.useEffect)(() => {
        //if you are using columned dropdownItem there should be at least 2 columns
        if (requiredRefs.current[0] && requiredRefs.current[1]) {
            for (let index = 0; index < columns.length; index++) {
                if (requiredRefs.current[index].offsetWidth <
                    requiredRefs.current[index].scrollWidth) {
                    setShowTooltip(true);
                }
            }
        }
    }, []);
    const getLabelToShow = (text, query) => {
        const matches = (0, match_1.default)(text.toString(), query);
        const parts = (0, parse_1.default)(text.toString(), matches);
        return parts.map((part, index) => (react_1.default.createElement("span", { key: `${part.text}-${String(index)}`, style: { fontWeight: part.highlight ? 800 : 500 } }, part.text)));
    };
    const columnsToShow = [...columns].map((col, index) => {
        let setWidth = 'auto';
        if (col === null || col === void 0 ? void 0 : col.width) {
            setWidth = col.width.toString();
        }
        return (react_1.default.createElement(DropdownItem_styles_1.StyledColumnedItemLabel, { key: col.key, height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: setWidth, paddingLeft: Dropdown_styles_1.ITEM_PADDING_LEFT },
            react_1.default.createElement(DropdownItem_styles_1.StyledColumnedItemText, { height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: setWidth, disabled: disabled, ref: (el) => (requiredRefs.current[index] = el) }, getLabelToShow(suggestion[col.key], query))));
    });
    const Item = (react_1.default.createElement(DropdownItem_styles_1.StyledColumnedItemContainer, null,
        react_1.default.createElement(DropdownItem_styles_1.StyledColumnedItemElement, { disabled: disabled, "data-testid": "dropdown-item", onClick: disabled
                ? () => {
                    console.info('option is disabled');
                }
                : props.onClick }, columnsToShow.map((column) => column))));
    if (!showTooltip) {
        return Item;
    }
    return (react_1.default.createElement(Tooltip_1.Tooltip, { style: { zIndex: 10000 }, title: columns
            .map((col) => {
            return suggestion[col.key];
        })
            .join(' - '), key: suggestion[columns[1].key] }, Item));
};
exports.StyledColumnedDropdownItem = StyledColumnedDropdownItem;
exports.default = exports.StyledColumnedDropdownItem;
//# sourceMappingURL=ColumnedDropdownItem.js.map